// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__he3Bk","logo":"NavBar_logo__NRwKm","menu":"NavBar_menu__F8Sob","authButton":"NavBar_authButton__GyxtJ","navbarContainer":"NavBar_navbarContainer__Eh22P"};